import {
  JavaScriptPlugin,
  MappingFunctionPlugin,
  MustachePlugin,
  QueryPlugin,
  TransformerPlugin,
  VariablePlugin
} from '@rehaje/lowcode'
import { entries } from '@rehaje/shared'

import { createWidgetPlugin } from './factories'
import {
  SchemaAnyPlugin,
  SchemaArrayPlugin,
  SchemaBigIntPlugin,
  SchemaBooleanPlugin,
  SchemaDatePlugin,
  SchemaDateTimePlugin,
  SchemaDynamicPlugin,
  SchemaFunctionPlugin,
  SchemaIntersectionPlugin,
  SchemaMapPlugin,
  SchemaNullPlugin,
  SchemaNumberPlugin,
  SchemaObjectPlugin,
  SchemaReferencePlugin,
  SchemaSetPlugin,
  SchemaStringPlugin,
  SchemaTypedSchemaPlugin,
  SchemaUndefinedPlugin,
  SchemaUnionPlugin,
  SchemaUnknownPlugin,
  SchemaURLSearchParamsPlugin,
  SchemaVoidPlugin
} from './plugins'
import { SchemaIterablePlugin } from './plugins/Schema.Iterable'

import type { FormPluginProps } from './types'
import type { PluginLike, RehajePlugin } from '@rehaje/core'

export class FormPlugin implements RehajePlugin {
  plugins: PluginLike[]

  constructor(props?: FormPluginProps) {
    this.plugins = [
      ...entries(props?.components ?? {}).map(([type, component]) =>
        createWidgetPlugin(type, component, props?.prefix)
      ),
      new MustachePlugin(),
      new JavaScriptPlugin(),
      new VariablePlugin(),
      new TransformerPlugin(),
      new QueryPlugin(),
      new MappingFunctionPlugin(),
      new SchemaStringPlugin(),
      new SchemaArrayPlugin(),
      new SchemaNumberPlugin(),
      new SchemaAnyPlugin(),
      new SchemaUnknownPlugin(),
      new SchemaBigIntPlugin(),
      new SchemaBooleanPlugin(),
      new SchemaDatePlugin(),
      new SchemaDateTimePlugin(),
      new SchemaDynamicPlugin(),
      new SchemaFunctionPlugin(),
      new SchemaIntersectionPlugin(),
      new SchemaMapPlugin(),
      new SchemaSetPlugin(),
      new SchemaURLSearchParamsPlugin(),
      new SchemaNullPlugin(),
      new SchemaObjectPlugin(),
      new SchemaUndefinedPlugin(),
      new SchemaTypedSchemaPlugin(),
      new SchemaUnionPlugin(),
      new SchemaVoidPlugin(),
      new SchemaReferencePlugin(),
      new SchemaIterablePlugin()
    ]
  }
}
